import * as XLSX from 'xlsx';
import { export_beneficiaries_to_excel } from '../api/excel_api';

const formatMeetingDates = (student) => {
    const meetingDates = Array.isArray(student.meeting_dates)
        ? student.meeting_dates
        : (student.meeting_dates_csv
            ? student.meeting_dates_csv.split(',').filter(Boolean)
            : (student.meeting_date ? [student.meeting_date] : []));

    return meetingDates
        .map((meetingDate) => new Date(meetingDate).toLocaleDateString('he-IL'))
        .join(', ');
};
export async function exportAllStudentsToExcel(selectedBeneficiaryIds = [], filters = {}) {
    try {
        const shouldExportAll = !Array.isArray(selectedBeneficiaryIds) || selectedBeneficiaryIds.length === 0;
        if (shouldExportAll) {
            const hasFilters = Object.values(filters).some(Boolean);
            alert(hasFilters
                ? 'לא נבחרו נתמכים לייצוא, מייצא את כל התוצאות שעומדות בסינון'
                : 'לא נבחרו נתמכים לייצוא, מייצא הכל');
        }

        const data = await export_beneficiaries_to_excel(
            shouldExportAll ? [] : selectedBeneficiaryIds,
            filters
        );

        if (!data || data.length === 0) {
            alert('אין נתונים לייצוא');
            return;
        }

        const students = data.map(student => ({
            'ת.ז.': student.beneficiary_id || student.id || '',
            'שם פרטי': student.first_name || '',
            'שם משפחה': student.last_name || '',
            'כתובת': student.address || '',
            'אימייל': student.email || '',
            'פלאפון': student.phone || '',
            'מורה מקשרת': student.referring_teacher || '',
            "פלא' מורה מקשרת": student.teacher_phone || '',
            'דירוג מקרה': student.type_case || '',
            'הערות': student.comments || '',
            'שם ספק': student.provider_name || '',
            'תשלום לספק': student.provider_payment_method || '',
            'תשלום לנתמך': student.beneficiary_payment_method || student.payment_method || '',
            'תאריך שיק': student.check_date
                ? new Date(student.check_date).toLocaleDateString('he-IL')
                : '',
            'מספר שיק': student.check_number || '',
            'סכום שיק': student.check_amount || '',
            'סעיף': student.category || '',
            'סוג סיוע ורווחה': student.welfare_subcategory || '',
            'מספר מפגשים': student.meeting_count || '',
            'תאריכי מפגשים': formatMeetingDates(student),
            'סכום': student.amount || '',
            'תאריך פעולה': student.date ? new Date(student.date).toLocaleDateString('he-IL') : '',
            'הערות לפעולה': student.transaction_comments || ''
        }));

        const worksheet = XLSX.utils.json_to_sheet(students);
        worksheet['!sheetViews'] = [{ rightToLeft: true }];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'תלמידים');
        worksheet['!sheetViews'] = [{ rightToLeft: true }];
        workbook.Workbook = {
            Views: [{ RTL: true }],
            Sheets: [{ name: 'תלמידים', sheetId: 0, state: 'visible' }]
        };

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'תלמידות.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        alert('הקובץ הורד בהצלחה');
    }
    catch (err) {
        console.error('Excel export error:', err);
        alert(`ייצוא הנתונים לאקסל נכשל: ${err.message}`);
    }
}
